export default "__VITE_ASSET__056082af__"